<template>
    <div style="height:100%;">
        <DxTabPanel ref="tabPanel" style="height: 100%; transition:none;" :selected-index="selectedTabItemIndex" @title-click="onTabItemClick" :animation-enabled="false"
      :swipe-enabled="false">
            <DxTabItem title="Fejlesztési napló" icon="smalliconslayout">
                <template #default>
                    <dxScrollView :show-scrollbar="'onScroll'"
                                  :use-native="false">
                        <div class="level">
                            <div class="flex-column">
                                <h2>Fejlesztési napló</h2>
                                <h3>Nyitott fejlesztési napló</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceDevelopmentDiaryOpen"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridDevelopmentDiaryOpen">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center"
                                                  cell-template="idColumnTemplate" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="status" caption="Státusz" width="130">
                                            <DxLookup :data-source="TaskStatus"
                                                      value-expr="id"
                                                      display-expr="name" />
                                        </DxColumn>
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                                <h3>Lezárt fejlesztési napló</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceDevelopmentDiaryClosed"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridDevelopmentDiaryClosed">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center"
                                                  cell-template="idColumnTemplate" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="end_date" data-type="date" :customize-text="dateFormat" caption="Befejezés dátuma" width="150" />
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                            </div>
                        </div>
                    </dxScrollView>
                </template>
            </DxTabItem>
            <DxTabItem title="Továbbfejlesztési javaslatok" icon="smalliconslayout">
                <template #default>
                    <dxScrollView :show-scrollbar="'onScroll'"
                                  :use-native="false">
                        <div class="level">
                            <div class="flex-column">
                                <h2>Továbbfejlesztési javaslatok</h2>
                                <h3>Nyitott továbbfejlesztési javaslatok</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceImprovementProposalsOpen"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridImprovementProposalsOpen">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center"
                                                  cell-template="idColumnTemplate" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="status" caption="Státusz" width="130">
                                            <DxLookup :data-source="TaskStatus"
                                                      value-expr="id"
                                                      display-expr="name" />
                                        </DxColumn>
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn data-field="unreadTaskCommentCount"
                                                  :width="38"
                                                  :allow-sorting="true"
                                                  caption="Új"
                                                  cell-template="unreadTaskCommentCountColumnTemplate" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                                <h3>Lezárt továbbfejlesztési javaslatok</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceImprovementProposalsClosed"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridImprovementProposalsClosed">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center"
                                                  cell-template="idColumnTemplate" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="end_date" data-type="date" :customize-text="dateFormat" caption="Befejezés dátuma" width="150" />
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn data-field="unreadTaskCommentCount"
                                                  :width="38"
                                                  :allow-sorting="true"
                                                  caption="Új"
                                                  cell-template="unreadTaskCommentCountColumnTemplate" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                            </div>
                        </div>
                    </dxScrollView>
                </template>
            </DxTabItem>
            <DxTabItem title="Hibabejelentések" icon="smalliconslayout">
                <template #default>
                    <dxScrollView :show-scrollbar="'onScroll'"
                                  :use-native="false">
                        <div class="level">
                            <div class="flex-column">
                                <h2>Hibabejelentések</h2>
                                <h3>Nyitott hibabejelentések</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceBugReportsOpen"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridBugReportsOpen">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="status" caption="Státusz" width="130">
                                            <DxLookup :data-source="TaskStatus"
                                                      value-expr="id"
                                                      display-expr="name" />
                                        </DxColumn>
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn data-field="unreadTaskCommentCount"
                                                  :width="38"
                                                  :allow-sorting="true"
                                                  caption="Új"
                                                  cell-template="unreadTaskCommentCountColumnTemplate" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #unreadTaskCommentCountColumnTemplate="{ data: cellInfo }">
                                            <div :class="getUnreadTaskCommentCountClass(cellInfo.data.unreadTaskCommentCount)">{{ showUnreadTaskCommentCount(cellInfo.data.unreadTaskCommentCount) }}</div>
                                        </template>

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                                <h3>Lezárt hibabejelentések</h3>
                                <div style="width:100%">
                                    <DxDataGrid :data-source="dataSourceBugReportsClosed"
                                                :column-auto-width="true"
                                                :row-alternation-enabled="true"
                                                :show-row-lines="true"
                                                @init-new-row="onInitNewRow"
                                                @row-prepared="onRowPrepared"
                                                ref="gridBugReportsClosed">

                                        <DxEditing :allow-updating="false"
                                                   :allow-deleting="false"
                                                   :allow-adding="false"
                                                   :use-icons="true"
                                                   mode="cell" />

                                        <DxPaging />
                                        <DxScrolling show-scrollbar="always"
                                                     column-rendering-mode="standard"
                                                     row-rendering-mode="standard"
                                                     :mode="'virtual'"
                                                     :preload-enabled="false" />

                                        <DxColumn data-field="id"
                                                  caption="#"
                                                  :allowEditing="false"
                                                  width="50"
                                                  alignment="center"
                                                  cell-template="idColumnTemplate" />
                                        <DxColumn data-field="name" caption="Megnevezés" />
                                        <DxColumn data-field="end_date" data-type="date" :customize-text="dateFormat" caption="Befejezés dátuma" width="150" />
                                        <DxColumn data-field="created_date" data-type="date" :customize-text="dateFormat" caption="Bejelentés dátuma" width="150" />
                                        <DxColumn data-field="lastCommentDate" data-type="date" :customize-text="dateFormat" caption="Utolsó bejegyzés dátuma" width="150" />
                                        <DxColumn data-field="unreadTaskCommentCount"
                                                  :width="38"
                                                  :allow-sorting="true"
                                                  caption="Új"
                                                  cell-template="unreadTaskCommentCountColumnTemplate" />
                                        <DxColumn :width="92"
                                                  :allow-sorting="false"
                                                  caption="Akciók"
                                                  alignment="center"
                                                  cell-template="actionsCellTemplate" />

                                        <template #idColumnTemplate="{ data: cellInfo }">
                                            {{ rowId(cellInfo) }}
                                        </template>

                                        <template #actionsCellTemplate="{ data: cellInfo }">
                                            <div class="dx-command-edit dx-command-edit-with-icons dx-cell-focus-disabled">
                                                <a href="#" class="dx-link dx-icon-info dx-link-icon" title="részletek" @click="showPopup(cellInfo, 'view')"></a>
                                            </div>
                                        </template>

                                    </DxDataGrid>
                                </div>
                            </div>
                        </div>
                        <!-- <ScreenshotEditor></ScreenshotEditor>-->
                    </dxScrollView>
                </template>
            </DxTabItem>
        </DxTabPanel>
    </div>
</template>

<script>
    import { TaskPriority } from "../enums/TaskPriority";
    import { TaskStatus } from "../enums/TaskStatus";
    import taskService from "../services/task.service";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxColumn,
        DxEditing,
        DxScrolling,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing
    } from "devextreme-vue/data-grid";
    import DxTabPanel, { DxItem as DxTabItem } from "devextreme-vue/tab-panel";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import DxPopup, { DxToolbarItem as DxPopupToolbarItem } from "devextreme-vue/popup";
    import DxTagBox from "devextreme-vue/tag-box";
    import DxList from "devextreme-vue/list";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import CustomStore from "devextreme/data/custom_store";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxSelectBox from "devextreme-vue/select-box";
    import { TaskType } from "../enums/TaskType";

    const gridRefNames = [
        'gridDevelopmentDiaryOpen',
        'gridDevelopmentDiaryClosed',
        'gridImprovementProposalsOpen',
        'gridImprovementProposalsClosed',
        'gridBugReportsOpen',
        'gridBugReportsClosed'
    ];

    export default {
        name: 'Tasks',
        components: {
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxColumn,
            DxEditing,
            DxScrolling,
            DxLookup,
            DxTagBox,
            DxRequiredRule,
            DxPopup,
            DxPosition,
            DxDatagridEditForm,
            DxFormItem,
            DxToolbar,
            DxToolbarItem,
            DxButton,
            DxButtonItem,
            DxLabel,
            DxDataGridEditPopup,
            DxForm,
            DxPopupToolbarItem,
            DxColumnFixing,
            DxSelectBox,
            DxList,
            DxDataGrid,
            DxTabPanel,
            DxTabItem,
            DxScrollView,
            TaskPriority,
            TaskStatus,
            TaskType
        },
        data() {
            return {
                tabItemRoutes: [
                    /* 0: */'/developmentInfo/changelog',
                    /* 1: */'/developmentInfo/featureRequests',
                    /* 2: */'/developmentInfo/bugReports'
                ],
                TaskPriority: TaskPriority,
                TaskStatus: TaskStatus,
                TaskType: TaskType,
                selectedTabItemIndex: 0,
                dataSourceBugReportsOpen: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 1, taskStatus: 'open' }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                dataSourceBugReportsClosed: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 1, taskStatus: 'closed' }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                dataSourceImprovementProposalsOpen: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 2, taskStatus: 'open'  }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                dataSourceImprovementProposalsClosed: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 2, taskStatus: 'closed' }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                dataSourceDevelopmentDiaryOpen: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 3, taskStatus: 'open' }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                dataSourceDevelopmentDiaryClosed: new CustomStore({
                    key: "id",
                    load: () => taskService.get({ taskType: 3, taskStatus: 'closed' }),
                    insert: (values) => {
                        return taskService.insert(values);
                    },
                    update: (key, values) =>
                        taskService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => taskService.delete(key)
                }),
                grids: {}
            };
        },
        created() {
            this.selectedTabItemIndex = this.tabItemRoutes.indexOf(this.$root._route.path);

            this.$root.$on('task_data_changed', (changeType, data) => {
                gridRefNames.forEach((gridRefName, index) => {
                    if (this.grids[gridRefName] !== undefined) {
                        this.grids[gridRefName].refresh();
                    }
                    else {
                        if (this.$refs[gridRefName] !== undefined && this.$refs[gridRefName].instance) {
                            this.grids[gridRefName] = this.$refs[gridRefName].instance;
                            this.grids[gridRefName].refresh();
                        }
                    }
                });
            });
        },
        mounted() {
        },
        methods: {
            onTabItemClick(e) {
                this.$router.push(this.tabItemRoutes[e.itemIndex]);
            },
            onInitNewRow(e) {
                e.data.status = 1;
                e.data.type = 1;
                e.data.priority = 2;

                new Promise(resolve => setTimeout(resolve, 5)).then(() => {
                    e.component.saveEditData();
                });
            },
            onRowPrepared(e) {
                if (e.component.getVisibleRows()[e.rowIndex] &&
                    e.component.getVisibleRows()[e.rowIndex].isNewRow &&
                    e.rowType == 'data')
                    e.rowElement.classList.add('d-none');
            },
            dateFormat(cellInfo) {
                let date = cellInfo.value;
                if (typeof date == undefined)
                    return null;

                var formatter = new Intl.DateTimeFormat('hu-HU', { month: "numeric", day: "numeric", year: "numeric" });
                return formatter.format(date);
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            showPopup(cellInfo, type) {

                let popupMode;

                if (type == 'edit') popupMode = 'edit_task';
                else popupMode = 'view_task';

                this.$root.$emit(popupMode, cellInfo.data.id);
            },
            showUnreadTaskCommentCount(count) {
                if (count > 0) {
                    return count;
                } else return '';
            },
            getUnreadTaskCommentCountClass(count) {
                if (count > 0) {
                    return 'comment-count';
                } else return '';
            }
        },
        watch: {
            $route(to, from) {
                if (to != from) {
                    let itemRouteIntex = this.tabItemRoutes.indexOf(to.path);
                    if (itemRouteIntex != -1 && this.selectedTabItemIndex != itemRouteIntex) {
                        this.selectedTabItemIndex = itemRouteIntex;
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    h3 {
        padding-top: 30px;
        padding-bottom: 15px;
    }
    .level {
        padding: 8px;
        padding-bottom: 30px;
    }

    .level:nth-child(even) {
        background-color: #dddddd;
    }

    .level-title {
        font-size: 22px;
        font-weight: bold;
    }
    ::v-deep .dx-datagrid .dx-row {
        background-color: #ffffff;
    }

    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }

    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-button-content {
        padding: 5px;
    }

    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }

    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }

    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }

    .comment-count {
        text-align: center;
        background-color: red;
        color: #fff;
        font-weight: bold;
        -webkit-border-radius: 22px;
        -moz-border-radius: 22px;
        border-radius: 22px;
        display: inline-block;
        width: 22px;
        height: 22px;
        padding-right: 2px;
        padding-top: 1px;
    }
</style>
